<template>
  <div class="my-10">
    <div class="flex justify-center px-4 items-center">
      <h1 class="text-3xl font-bold text-center">{{ __("Add consent form") }}</h1>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 ">
      <div class="max-w-5xl w-full mx-auto my-10">
        <form class="mt-2" @submit.prevent="submit">
          <div>
            <text-input v-model="form.name" :data-error="error('name', 'consentForm')" class="w-full pb-8" :label="__('Name')"/>
          </div>
          <div>
            <editor id="editor" v-model="form.body" class="w-full pb-8" :label="__('Content')"/>
            <div v-if="error('body', 'consentForm')" class="text-red-500 text-sm -mt-6">{{ error('body', 'consentForm') }}</div>
          </div>

          <div class="flex justify-center items-center mt-4">
            <loading-button :loading="sendingForm" class="btn-primary" type="submit">
              {{ __("Save") }}
            </loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import TextInput from '@/Shared/TextInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import Editor from '@/Shared/Editor';
  import Icon from '@/Shared/Icon';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Add consent form")
      }
    },
    data() {
      return {
        sendingForm: false,
        form: {
          name: '',
          body: ''
        }
      }
    },
    components: {
      Layout,
      TextInput,
      LoadingButton,
      Editor,
      Icon
    },
    methods: {
      submit() {
        this.sendingForm = true;
        this.$inertia.post(this.route('consentForms.store'), this.form, {preserveState: false});
      }
    }
  }
</script>

